import LandingPage from './LandingPage'

const RoofLanding = () => (
  <LandingPage
    image="/landings/roof-landing.jpg"
    alt="Miami Weather is Tough. Your Roof Should Be Tougher — Complete Replacement or Repair with Hurricane-Proof Materials"
    formUrl="/landing-roof-form"
    title="Roofing Services"
    headline="Your Roof Should Be Tougher."
    subtitle="Professional roof installation, replacement, and repair with Miami-Dade NOA-approved, hurricane-proof materials. Precision, durability, and guaranteed workmanship backed by a 10-year warranty."
    features={['Complete Replacement', 'Hurricane-Proof Materials', 'Miami-Dade Approved', '10-Year Warranty']}
    cta="GET YOUR REPLACEMENT ROOF QUOTE NOW!"
  />
)

export default RoofLanding
